module.exports = __webpack_public_path__ + "static/img/Mitch_Duncan_desktop.3e99d21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Mitch_Duncan_desktop.jpg
// module id = lKcv
// module chunks = 0